import { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, DialogActions, useMediaQuery } from "@mui/material";
// material
import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";
// components
import Page from "../components/Page";
// import AuthSocial from '../components/authentication/AuthSocial';
import Translate from "../utils/Translate";
import Preloader from "../components/Preloader";
import { getQueryParam } from "../utils/uriHelper";
import Logo from "../components/Logo";
import { useNavigate, useParams } from "react-router-dom";
import BankIdAuthentication from "../components/bankId/BankIdAuthentication";
import { accessKeys, hasAccess, hasSomeAccess, resetAccess, setAccess } from "../utils/userAccess";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: "flex",
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 498,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  //padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function PermitResponsibleViewLoginPage() {
  const [dataFetched, setDataFetched] = useState(false);
  const [isTimeout, setIsTimeout] = useState(getQueryParam("timeout"));
  const navigate = useNavigate();

  const smallScreen = useMediaQuery("(max-width:700px)");
  const logoContainerClassName = `permitResponsibleLoginBoxHeader${smallScreen ? " small" : ""}`;
  const logoSx = !smallScreen ? { filter: "invert(1)", width: "300px" } : { filter: "invert(1)" };

  useEffect(() => {
    async function init() {
      await Translate.loadPreLogin(29);
      setDataFetched(true);
    }
    init();
  }, []);

  async function onAuthenticationSuccess(loginType, response) {
    const data = response.data;
    if (data.isSuccessful) {
      resetAccess();
      setAccess(data.access);
      await Translate.loadApp(29, false);
      navigate("/responsible-view/permits");
    }
  }

  function handleTimeoutOk() {
    setIsTimeout(false);
  }

  return (
    <RootStyle className={smallScreen ? "loginPagePermitsMobile" : "loginPagePermits"}>
      {!dataFetched && !isTimeout && <Preloader />}

      {isTimeout && (
        <Dialog open={true}>
          <DialogContent>{Translate.get("LoggedOutTimeout")}</DialogContent>
          <DialogActions>
            <Button onClick={handleTimeoutOk}>{Translate.get("Ok")}</Button>
          </DialogActions>
        </Dialog>
      )}

      {!isTimeout && (
        <Container maxWidth="sm">
          <ContentStyle>
            <div className="permitResponsibleLoginBox">
              <div className={logoContainerClassName}>
                <Logo sx={logoSx} />
                <div>{Translate.get("LoginPermitResponsible")}</div>
              </div>
              <form className="loginForm">
                <BankIdAuthentication
                  startAuthenticationUrl={`${import.meta.env.VITE_KORTILLSTAND_AUTH_URL}auth/bankid/v2/login/permit-responsible-view`}
                  fetchStatusIncludeCredentials={true}
                  onAuthenticationSuccess={onAuthenticationSuccess}
                  qrCodeQueryParams={{ darkColorHex: "#FFFFFF", lightColorHex: "#646464" }}
                  sxCardOverride={{ backgroundColor: "#646464", boxShadow: "none", color: "#fff", height: "300px" }}
                  sxTextOverride={{ color: "#FFFFFF" }}
                  classNameButtonTextOverride="whiteButtonText roundFlatButton"
                  classNameButtonContainedOverride="grayButtonContained roundFlatButton"
                />
              </form>
              <div className="permitResponsibleLoginBoxFooter">
                <a href="/login">{Translate.get("SwitchToPermitAdmin")}</a>
              </div>
            </div>
          </ContentStyle>
        </Container>
      )}
    </RootStyle>
  );
}
